module.exports = __webpack_public_path__ + "assets/img/snapfail.2ced55a5.png";